import { AppLicense } from '@core/licenses';
import { environment } from '@environment';
import { InjectionToken } from '@angular/core';
import { API_URL_CONFIG } from '@root/api-url.config';
import { GrpcTransport } from '@shared/grpc-transport/grpc-transport';
import { FetchGrpcTransport } from '@shared/grpc-transport/fetch-grpc-transport';
import { LoggerGrpcTransport } from '@shared/grpc-transport/logger-grpc-transport';

export const ORIGIN_TRANSPORT = new InjectionToken<GrpcTransport>(
  'ORIGIN_TRANSPORT',
  {
    providedIn: 'root',
    factory: () =>
      new LoggerGrpcTransport(
        new FetchGrpcTransport(getGrpcHost()),
      ),
  },
);

function getGrpcHost(): string {
  const license = window.location.pathname.split('/').at(2) as AppLicense;
  const apiConfig = API_URL_CONFIG[environment.env][license];

  return apiConfig?.grpcHost || environment.grpcHost;
}
